import PropTypes from "prop-types";
import { SparklesSolidV6, SpinnerSolidV6 } from "@shared/v2/Icomoon";

const AICallSummaryStatus = ({ callComplete }) => (
  <div className="tw-bg-[#f9f7fd] tw-text-[#572bad] tw-text-12d tw-font-semibold tw-mt-[-12px] tw-pt-[20px] tw-pb-[8px] tw-px-[16px] tw-border-solid tw-border-[1px] tw-border-semantic-purple-10 tw-rounded-[8px] tw-flex tw-flex-col tw-gap-[4px] tw-overflow-hidden">
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-[4px] tw-flex-wrap">
      <div className="tw-flex tw-items-center tw-gap-[4px] tw-whitespace-nowrap">
        <SparklesSolidV6 /> Call Summary
      </div>
      {!callComplete && (
        <div className="tw-flex tw-items-center tw-gap-[4px] tw-whitespace-nowrap">
          <SpinnerSolidV6 className="tw-animate-spin" /> In process
        </div>
      )}
    </div>
    {callComplete && (
      <div className="tw-italic">Processing. A call summary will be added to this call timeline event.</div>
    )}
  </div>
);

AICallSummaryStatus.propTypes = {
  callComplete: PropTypes.bool.isRequired,
};

export default AICallSummaryStatus;
